var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "branch-card"
  }, [_vm.content.header || _vm.content.title ? _c('div', {
    class: ['branch-body', _vm.isPC ? 'branch-bubble' : 'branch-bubble-h5']
  }, [_c('Icon', {
    staticClass: "branch-title-icon",
    attrs: {
      "src": _vm.iconQuestion
    }
  }), _c('div', {
    staticClass: "branch-title-text"
  }, [_vm._v(" " + _vm._s(_vm.content.header || _vm.content.title) + " ")])], 1) : _vm._e(), _vm._l(_vm.content.items, function (item, index) {
    return _c('div', {
      key: index,
      class: ['branch-body', _vm.isPC ? 'branch-bubble' : 'branch-bubble-h5', 'branch-item', _vm.isSelected ? 'branch-item-selected' : '', item.content ? '' : 'warning-item'],
      style: {
        borderWidth: _vm.content.header ? '1px 0 0px 0' : ''
      },
      on: {
        "click": function ($event) {
          return _vm.handleContentListItemClick(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.content || _vm.TUITranslateService.t('AIDesk.分支选项异常')) + " ")]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }